<div class="content">
    <span class="dot" [class]="updateStatus()"></span>
    <div class="brand">
        <app-logo />
        <span class="brand-label">{{ 'header.brand-label' | translate }}</span>
        <span class="build">{{ version }}</span>
    </div>
    <div class="actions">
        <button type="button" class="scan" (click)="openScannedCode()">
            <app-icon name="scan" />
            <span>{{ 'scanned-code.open' | translate }}</span>
        </button>
        <a class="user" routerLink="/mode/profile" [title]="userTitle()" [attr.aria-label]="'profile.title' | translate">
            <app-icon name="user" />
            @if (userName()) {
                <span class="uname">{{ userName() }}</span>
            }
        </a>
    </div>
</div>
